"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./get-full/index");
var index_2 = require("./convert/index");
var leap_1 = require("./leap");
var PersainDate = /** @class */ (function () {
    function PersainDate() {
    }
    /**
     *this function returns the day after convention
     *
     * @param {string} date
     * @param {('fa' | 'en')} type
     * @returns {number}
     * @memberof PersainDate
     */
    PersainDate.prototype.getDay = function (date, type) {
        var day = index_1.default(date, type).day;
        return day;
    };
    /**
     *this function returns the month after convention
     *
     * @param {string} date
     * @param {('fa' | 'en')} type
     * @returns {number}
     * @memberof PersainDate
     */
    PersainDate.prototype.getMonth = function (date, type) {
        var month = index_1.default(date, type).month;
        return month;
    };
    /**
     *this function returns year after convention
     *
     * @param {string} date
     * @param {('fa' | 'en')} type
     * @returns {number}
     * @memberof PersainDate
     */
    PersainDate.prototype.getYear = function (date, type) {
        var year = index_1.default(date, type).year;
        return year;
    };
    /**
     *this function returns day's name
     *
     * @param {string} date
     * @param {('fa' | 'en')} type
     * @returns {string}
     * @memberof PersainDate
     */
    PersainDate.prototype.getDayName = function (date, type) {
        var dayName = index_1.default(date, type).dayName;
        return dayName;
    };
    /**
     *this function returns month's name after convention
     *
     * @param {string} date
     * @param {('fa' | 'en')} type
     * @returns {string}
     * @memberof PersainDate
     */
    PersainDate.prototype.getMonthName = function (date, type) {
        var monthName = index_1.default(date, type).monthName;
        return monthName;
    };
    /**
     *this function returns Unix time - from 1970-01-01
     *
     * @param {string} date
     * @param {('fa' | 'en')} type
     * @returns {number}
     * @memberof PersainDate
     */
    PersainDate.prototype.getNumeric = function (date, type) {
        var numeric = index_1.default(date, type).numeric;
        return numeric;
    };
    /**
     * get the full information after coverting the date
     *
     * @param {string} date
     * @param {('fa' | 'en')} type
     * @returns {getFullOutPut}
     * @memberof PersainDate
     */
    PersainDate.prototype.getFull = function (date, type) {
        return index_1.default(date, type);
    };
    /**
     *this function will convert date to gregorian and jalali with custom output format
     *
     * @param {string} date
     * @param {('fa' | 'en')} type
     * @param {string} [format] -> y-m-d T h:min:sec.msec
     * @returns {string}
     * @memberof PersainDate
     */
    PersainDate.prototype.convert = function (date, type, format) {
        return index_2.default(date, type, format);
    };
    /**
     *this function determind the year is leap in jalali calendar on not
     *
     * @param {number} year
     * @returns {(Boolean|null)}
     * @memberof PersainDate
     */
    PersainDate.prototype.isPersianLeap = function (year) {
        return leap_1.leap(year, 'fa');
    };
    /**
     *this function determind the year is leap in Gregorian calendar on not
     *
     * @param {number} year
     * @returns {(Boolean|null)}
     * @memberof PersainDate
     */
    PersainDate.prototype.isGregorianLeap = function (year) {
        return leap_1.leap(year, 'en');
    };
    return PersainDate;
}());
exports.default = PersainDate;
